<template>
  <div class="filterJob" :class="$IsMobile ? 'mobile' : ''">
    <el-input
      class="input-with-select"
      placeholder="请输入关键字"
      clearable
      v-model="searchParam.keyword"
      maxlength="20"
      show-word-limit
    >
      <el-button slot="append" icon="el-icon-search" @click="handleSearch"
        >搜索职位</el-button
      >
    </el-input>
    <ul>
      <li :class="{ active: showMenu }" @click="showMenu = true">
        <span class="liLabel">性质{{ $IsMobile ? "" : "：" }}</span>
        <el-radio-group v-model="searchParam.willNature" @change="handleSearch">
          <el-radio-button label="">不限</el-radio-button>
          <el-radio-button
            v-for="will in willNatureOptions"
            :key="will.id"
            :label="will.value"
          >
            {{ will.label }}
          </el-radio-button>
        </el-radio-group>
      </li>
      <li :class="{ active: showMenu }" @click="showMenu = true">
        <span class="liLabel">薪资{{ $IsMobile ? "" : "：" }}</span>
        <el-checkbox-group
          v-model="wage"
          @change="(wage = check(wage)), handleWageSearch(wage)"
        >
          <el-checkbox-button label="">不限</el-checkbox-button>
          <el-checkbox-button
            v-for="wage in wageOptions"
            :label="wage.id"
            :key="wage.id"
            >{{ wage.name }}
          </el-checkbox-button>
        </el-checkbox-group>
      </li>
    </ul>
  </div>
</template>

<script>
import { getTreeListByDictType } from "@/api/dict";

export default {
  name: "CommonSearch",
  data() {
    return {
      wage: [''], //薪资
      searchParam: {
        keyword: "", //关键字
        willNature: "", // 工作性质（实习，兼职，全职）
        wageList: [], //
      },
      willNatureOptions: [], // 工作性质
      wageOptions: [
        { id: 1, name: "2k以下", minimumWage: 0, maximumWage: 2000 },
        { id: 2, name: "2-4k", minimumWage: 2000, maximumWage: 4000 },
        { id: 3, name: "5-6k", minimumWage: 5000, maximumWage: 6000 },
        { id: 4, name: "6-8k", minimumWage: 6000, maximumWage: 8000 },
        { id: 5, name: "8-10k", minimumWage: 8000, maximumWage: 10000 },
        { id: 6, name: "10-12k", minimumWage: 10000, maximumWage: 12000 },
        { id: 7, name: "12-14k", minimumWage: 12000, maximumWage: 14000 },
        { id: 8, name: "14-16k", minimumWage: 14000, maximumWage: 16000 },
        { id: 9, name: "16-18k", minimumWage: 16000, maximumWage: 18000 },
        { id: 10, name: "18-20k", minimumWage: 18000, maximumWage: 20000 },
        { id: 11, name: "20k以上", minimumWage: 20000, maximumWage: 9999999 },
      ],
      showMenu: false,
    };
  },
  created() {
    this.loadDictData();
  },
  methods: {
    handleSearch() {
      this.$emit("search", this.searchParam);
      this.showMenu = false;
    },
    loadDictData() {
      this.$store
        .dispatch("global/getTreeListByDictType", "work_nature")
        .then((data) => {
          this.willNatureOptions = data;
        });
    },
    check(value) {
      if (value.length > 0) {
        if (value[value.length - 1] === "") {
          return value.splice(-1);
        } else {
          if (value.length > 1 && value[0] === "") {
            return value.splice(1);
          }
        }
      } else {
        value.unshift("");
        return value.splice(-1);
      }
      return value;
    },
    handleWageSearch(val) {
      this.searchParam.wageList = [];
      if (val[0] === "") {
        val = [];
      }
      val.forEach((index) => {
        let item = this.wageOptions.find((x) => x.id == index);
        let minWage = 0;
        let maxWage = 0;
        if (item) {
          minWage = item.minimumWage;
          maxWage = item.maximumWage ? item.maximumWage : "";
        }
        this.searchParam.wageList.push({
          minimumWage: minWage,
          maximumWage: maxWage,
        });
      });
      this.handleSearch();
      this.showMenu = false;
    },
  },
};
</script>

<style scoped lang="scss">
.filterJob.mobile {
  background: #fff;
  padding-top: 15px;
  border-radius: 10px;
  .liLabel {
    margin: 0;
    padding: 6px 22px 6px 12px;
    background: #f4f5fa;
    border-radius: 4px;
    height: 20px;
    line-height: 20px;
    &::before {
      right: 12px;
      bottom: 8px;
    }
  }
}
</style>
